import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  Input,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-external-meeting-scheduler',
  templateUrl: './external-meeting-scheduler.component.html',
  styleUrls: ['./external-meeting-scheduler.component.scss']
})
export class ExternalMeetingSchedulerComponent implements OnInit {
  // @Input() events: CalendarEvent[];
  events: any;

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  // view: CalendarView = CalendarView.Month;
  view: CalendarView = CalendarView.Week;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();

  // events: CalendarEvent[] = [
  //   {
  //     start: new Date(),
  //     end: new Date(),
  //     title: 'Sample Event',
  //     color: colors.red,
  //     allDay: true
  //   }
  // ];

  user_details: any;

  activeDayIsOpen: boolean = false;

  user_id: any;
  user_name: any;
  user_email: any;

  constructor(
    private modal: NgbModal,
    public commonService: CommonService,
    private dialog: MatDialog,
    private activeRoute: ActivatedRoute,
  ) {
    this.activeRoute.queryParams.subscribe((params) => {
      this.user_id = params.id;
      this.user_name = params.name;
      this.user_email = params.email;
    });
  }

  ngOnInit(): void {
    this.getEventsData();
    this.generateDurationSlots();
    this.generateTimeZones();
  }

  page_loaded: boolean = false;
  getEventsData() {
    this.page_loaded = false;
    this.commonService.getData('/getgoogleevents/?unique_id=' + this.user_id).subscribe(
			(res: any) => {
				this.events = res;
        // this.events = [
        // 	{
        // 		title: "Chaitanya Kunduru",
        // 		description: "Chaitanya Kunduru 123",
        // 		start: new Date("2026-03-31T16:15:34.668Z"),
        // 		end: new Date("2026-03-31T17:17:34.668Z"),
        // 	},
        // 	{
        // 		title: "Ina",
        // 		description: "Ina 123",
        // 		start: new Date("2026-03-31T20:15:34.668Z"),
        // 		end: new Date("2026-03-31T21:17:34.668Z"),
        // 	},
        // 	{
        // 		title: "RK",
        // 		description: "RK 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Chaitanya Kunduru",
        // 		description: "Chaitanya Kunduru 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Ina",
        // 		description: "Ina 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "RK",
        // 		description: "RK 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Chaitanya Kunduru",
        // 		description: "Chaitanya Kunduru 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Ina",
        // 		description: "Ina 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "RK",
        // 		description: "RK 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Chaitanya Kunduru",
        // 		description: "Chaitanya Kunduru 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Ina",
        // 		description: "Ina 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "RK",
        // 		description: "RK 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Chaitanya Kunduru",
        // 		description: "Chaitanya Kunduru 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "Ina",
        // 		description: "Ina 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	},
        // 	{
        // 		title: "RK",
        // 		description: "RK 123",
        // 		start: new Date(),
        // 		end: new Date(),
        // 	}
        // ];
        for (let index = 0; index < this.events.length; index++) {
          this.events[index].start = new Date(this.events[index].start);
          // this.events[index].end = new Date(this.events[index].end);
          if (this.events[index].allDay == true) {
            const end_date = JSON.parse(
              JSON.stringify(new Date(this.events[index].end)),
            );
            this.events[index].end_date = end_date;
            this.events[index].end = '';
          } else {
            this.events[index].end = new Date(this.events[index].end);
            this.events[index].end_date = new Date(
              this.events[index].end,
            );
          }
        }
        this.page_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
        this.events = [];
        this.page_loaded = true;
			},
		);
  }

  duration_slots: any = [];
	generateDurationSlots() {
		const totalMinutesInDay = 24 * 60;
		const interval = 15; // 15-minute intervals

		this.duration_slots = [];

		for (let minutes = interval; minutes <= totalMinutesInDay; minutes += interval) {
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			let duration = '';

			if (hours > 0) {
				duration += `${hours} hour${hours > 1 ? 's' : ''}`;
			}

			if (remainingMinutes > 0) {
				if (hours > 0) {
					duration += ' ';
				}
				duration += `${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
			}

			this.duration_slots.push({ name: duration, value: minutes });

		}
	}

  timezone_list: any = [];
	generateTimeZones() {
		const timeZonesObject = {
			"Pacific/Midway": "(GMT-11:00) Midway Island, Samoa",
			"Pacific/Pago_Pago": "(GMT-11:00) Pago Pago",
			"Pacific/Honolulu": "(GMT-10:00) Hawaii",
			"America/Anchorage": "(GMT-8:00) Alaska",
			"America/Juneau": "(GMT-8:00) Juneau",
			"America/Vancouver": "(GMT-7:00) Vancouver",
			"America/Los_Angeles": "(GMT-7:00) Pacific Time (US and Canada)",
			"America/Tijuana": "(GMT-7:00) Tijuana",
			"America/Phoenix": "(GMT-7:00) Arizona",
			"America/Edmonton": "(GMT-6:00) Edmonton",
			"America/Denver": "(GMT-6:00) Mountain Time (US and Canada)",
			"America/Mazatlan": "(GMT-6:00) Mazatlan",
			"America/Regina": "(GMT-6:00) Saskatchewan",
			"America/Guatemala": "(GMT-6:00) Guatemala",
			"America/El_Salvador": "(GMT-6:00) El Salvador",
			"America/Managua": "(GMT-6:00) Managua",
			"America/Costa_Rica": "(GMT-6:00) Costa Rica",
			"America/Tegucigalpa": "(GMT-6:00) Tegucigalpa",
			"America/Chihuahua": "(GMT-6:00) Chihuahua",
			"America/Winnipeg": "(GMT-5:00) Winnipeg",
			"America/Chicago": "(GMT-5:00) Central Time (US and Canada)",
			"America/Mexico_City": "(GMT-5:00) Mexico City",
			"America/Panama": "(GMT-5:00) Panama",
			"America/Bogota": "(GMT-5:00) Bogota",
			"America/Lima": "(GMT-5:00) Lima",
			"America/Monterrey": "(GMT-5:00) Monterrey",
			"America/Montreal": "(GMT-4:00) Montreal",
			"America/New_York": "(GMT-4:00) Eastern Time (US and Canada)",
			"America/Indianapolis": "(GMT-4:00) Indiana (East)",
			"America/Puerto_Rico": "(GMT-4:00) Puerto Rico",
			"America/Caracas": "(GMT-4:00) Caracas",
			"America/Santiago": "(GMT-4:00) Santiago",
			"America/La_Paz": "(GMT-4:00) La Paz",
			"America/Guyana": "(GMT-4:00) Guyana",
			"America/Halifax": "(GMT-3:00) Halifax",
			"America/Montevideo": "(GMT-3:00) Montevideo",
			"America/Araguaina": "(GMT-3:00) Recife",
			"America/Argentina/Buenos_Aires": "(GMT-3:00) Buenos Aires, Georgetown",
			"America/Sao_Paulo": "(GMT-3:00) Sao Paulo",
			"Canada/Atlantic": "(GMT-3:00) Atlantic Time (Canada)",
			"America/St_Johns": "(GMT-2:30) Newfoundland and Labrador",
			"America/Godthab": "(GMT-2:00) Greenland",
			"Atlantic/Cape_Verde": "(GMT-1:00) Cape Verde Islands",
			"Atlantic/Azores": "(GMT+0:00) Azores",
			"UTC": "(GMT+0:00) Universal Time UTC",
			"Etc/Greenwich": "(GMT+0:00) Greenwich Mean Time",
			"Atlantic/Reykjavik": "(GMT+0:00) Reykjavik",
			"Africa/Casablanca": "(GMT+0:00) Casablanca",
			"Africa/Nouakchott": "(GMT+0:00) Nouakchott",
			"Europe/Dublin": "(GMT+1:00) Dublin",
			"Europe/London": "(GMT+1:00) London",
			"Europe/Lisbon": "(GMT+1:00) Lisbon",
			"Africa/Bangui": "(GMT+1:00) West Central Africa",
			"Africa/Algiers": "(GMT+1:00) Algiers",
			"Africa/Tunis": "(GMT+1:00) Tunis",
			"Europe/Belgrade": "(GMT+2:00) Belgrade, Bratislava, Ljubljana",
			"CET": "(GMT+2:00) Sarajevo, Skopje, Zagreb",
			"Europe/Oslo": "(GMT+2:00) Oslo",
			"Europe/Copenhagen": "(GMT+2:00) Copenhagen",
			"Europe/Brussels": "(GMT+2:00) Brussels",
			"Europe/Berlin": "(GMT+2:00) Amsterdam, Berlin, Rome, Stockholm, Vienna",
			"Europe/Amsterdam": "(GMT+2:00) Amsterdam",
			"Europe/Rome": "(GMT+2:00) Rome",
			"Europe/Stockholm": "(GMT+2:00) Stockholm",
			"Europe/Vienna": "(GMT+2:00) Vienna",
			"Europe/Luxembourg": "(GMT+2:00) Luxembourg",
			"Europe/Paris": "(GMT+2:00) Paris",
			"Europe/Zurich": "(GMT+2:00) Zurich",
			"Europe/Madrid": "(GMT+2:00) Madrid",
			"Africa/Harare": "(GMT+2:00) Harare, Pretoria",
			"Europe/Warsaw": "(GMT+2:00) Warsaw",
			"Europe/Prague": "(GMT+2:00) Prague Bratislava",
			"Europe/Budapest": "(GMT+2:00) Budapest",
			"Africa/Tripoli": "(GMT+2:00) Tripoli",
			"Africa/Cairo": "(GMT+2:00) Cairo",
			"Africa/Johannesburg": "(GMT+2:00) Johannesburg",
			"Africa/Khartoum": "(GMT+2:00) Khartoum",
			"Europe/Helsinki": "(GMT+3:00) Helsinki",
			"Africa/Nairobi": "(GMT+3:00) Nairobi",
			"Europe/Sofia": "(GMT+3:00) Sofia",
			"Europe/Istanbul": "(GMT+3:00) Istanbul",
			"Europe/Athens": "(GMT+3:00) Athens",
			"Europe/Bucharest": "(GMT+3:00) Bucharest",
			"Asia/Nicosia": "(GMT+3:00) Nicosia",
			"Asia/Beirut": "(GMT+3:00) Beirut",
			"Asia/Damascus": "(GMT+3:00) Damascus",
			"Asia/Jerusalem": "(GMT+3:00) Jerusalem",
			"Asia/Amman": "(GMT+3:00) Amman",
			"Europe/Moscow": "(GMT+3:00) Moscow",
			"Asia/Baghdad": "(GMT+3:00) Baghdad",
			"Asia/Kuwait": "(GMT+3:00) Kuwait",
			"Asia/Riyadh": "(GMT+3:00) Riyadh",
			"Asia/Bahrain": "(GMT+3:00) Bahrain",
			"Asia/Qatar": "(GMT+3:00) Qatar",
			"Asia/Aden": "(GMT+3:00) Aden",
			"Africa/Djibouti": "(GMT+3:00) Djibouti",
			"Africa/Mogadishu": "(GMT+3:00) Mogadishu",
			"Europe/Kiev": "(GMT+3:00) Kiev",
			"Europe/Minsk": "(GMT+3:00) Minsk",
			"Asia/Dubai": "(GMT+4:00) Dubai",
			"Asia/Muscat": "(GMT+4:00) Muscat",
			"Asia/Baku": "(GMT+4:00) Baku, Tbilisi, Yerevan",
			"Asia/Tehran": "(GMT+4:30) Tehran",
			"Asia/Kabul": "(GMT+4:30) Kabul",
			"Asia/Yekaterinburg": "(GMT+5:00) Yekaterinburg",
			"Asia/Tashkent": "(GMT+5:00) Islamabad, Karachi, Tashkent",
			"Asia/Calcutta": "(GMT+5:30) India",
			"Asia/Kolkata": "(GMT+5:30) Mumbai, Kolkata, New Delhi",
			"Asia/Colombo": "(GMT+5:30) Asia/Colombo",
			"Asia/Kathmandu": "(GMT+5:45) Kathmandu",
			"Asia/Almaty": "(GMT+6:00) Almaty",
			"Asia/Dacca": "(GMT+6:00) Dacca",
			"Asia/Dhaka": "(GMT+6:00) Astana, Dhaka",
			"Asia/Rangoon": "(GMT+6:30) Rangoon",
			"Asia/Novosibirsk": "(GMT+7:00) Novosibirsk",
			"Asia/Krasnoyarsk": "(GMT+7:00) Krasnoyarsk",
			"Asia/Bangkok": "(GMT+7:00) Bangkok",
			"Asia/Saigon": "(GMT+7:00) Vietnam",
			"Asia/Jakarta": "(GMT+7:00) Jakarta",
			"Asia/Irkutsk": "(GMT+8:00) Irkutsk, Ulaanbaatar",
			"Asia/Shanghai": "(GMT+8:00) Beijing, Shanghai",
			"Asia/Hong_Kong": "(GMT+8:00) Hong Kong SAR",
			"Asia/Taipei": "(GMT+8:00) Taipei",
			"Asia/Kuala_Lumpur": "(GMT+8:00) Kuala Lumpur",
			"Asia/Singapore": "(GMT+8:00) Singapore",
			"Australia/Perth": "(GMT+8:00) Perth",
			"Asia/Yakutsk": "(GMT+9:00) Yakutsk",
			"Asia/Seoul": "(GMT+9:00) Seoul",
			"Asia/Tokyo": "(GMT+9:00) Osaka, Sapporo, Tokyo",
			"Australia/Darwin": "(GMT+9:30) Darwin",
			"Australia/Adelaide": "(GMT+9:30) Adelaide",
			"Asia/Vladivostok": "(GMT+10:00) Vladivostok",
			"Pacific/Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
			"Australia/Brisbane": "(GMT+10:00) Brisbane",
			"Australia/Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney",
			"Australia/Hobart": "(GMT+10:00) Hobart",
			"Asia/Magadan": "(GMT+11:00) Magadan",
			"SST": "(GMT+11:00) Solomon Islands",
			"Pacific/Noumea": "(GMT+11:00) New Caledonia",
			"Asia/Kamchatka": "(GMT+12:00) Kamchatka",
			"Pacific/Fiji": "(GMT+12:00) Fiji Islands, Marshall Islands",
			"Pacific/Auckland": "(GMT+12:00) Auckland, Wellington",
			"Pacific/Apia": "(GMT+13:00) Independent State of Samoa"
		};

		this.timezone_list = [];

		this.timezone_list = Object.keys(timeZonesObject).map(key => {
			return { value: key, name: `${key} : ${timeZonesObject[key]}` };
		});

	}

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventClicked({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEvent[];
  }): void {
    if (events.length > 0) {
      // this.handleEvent('Clicked', events);
      this.openDayEventModal({ date, events });
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: any): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  // addEvent(): void {
  //   this.events = [
  //     ...this.events,
  //     {
  //       title: 'New event',
  //       start: startOfDay(new Date()),
  //       end: endOfDay(new Date()),
  //       color: colors.red,
  //       draggable: true,
  //       resizable: {
  //         beforeStart: true,
  //         afterEnd: true,
  //       },
  //     },
  //   ];
  // }

  // deleteEvent(eventToDelete: CalendarEvent) {
  //   this.events = this.events.filter((event) => event !== eventToDelete);
  // }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  @ViewChild('dayEventsModal') dayEventsModal: TemplateRef<any>;
  private dayEventsModalRef: MatDialogRef<TemplateRef<any>>;

  selected_events_data: any = [];
  openDayEventModal(data) {
    this.selected_events_data = JSON.parse(JSON.stringify(data));
    this.dayEventsModalRef = this.dialog.open(this.dayEventsModal, {
      disableClose: true,
    });
    this.dayEventsModalRef.afterClosed().subscribe((result) => {
      this.closeDayEventModal();
    });
  }

  closeDayEventModal() {
    this.dayEventsModalRef.close();
    this.selected_events_data = {};
  }

  @ViewChild('specificEventsModal') specificEventsModal: TemplateRef<any>;
  private specificEventsModalRef: MatDialogRef<TemplateRef<any>>;
  specific_event_data: any = [];
  openSpecificEventModal(data) {
    this.specific_event_data = JSON.parse(JSON.stringify(data));
    this.specificEventsModalRef = this.dialog.open(this.specificEventsModal, {
      disableClose: true,
    });
    this.specificEventsModalRef.afterClosed().subscribe((result) => {
      this.closeSpecificEventModal();
    });
  }

  closeSpecificEventModal() {
    this.specificEventsModalRef.close();
    this.specific_event_data = {};
  }

  onHourSegmentClick(date: Date) {
    if (this.isPast(date)) {
      return;
    }

    this.openCreateEventModal(date);
  }

  isPast(date: Date): boolean {
  return date.getTime() < new Date().getTime();
}

  @ViewChild('createEventModal') createEventModal: TemplateRef<any>;
  private createEventModalRef: MatDialogRef<TemplateRef<any>>;
  create_meeting_data: any = {
    topic: "",
    start_date: "",
    end_date: "",
    duration: "",
    timezone: "",
  };
  create_meeting_data_errors: any = {
    topic: false,
    start_date: false,
    end_date: false,
    duration: false,
    timezone: false,
  };
  openCreateEventModal(date) {
    this.create_meeting_data.start_date = date;
    // this.create_meeting_data.end_date = new Date(date.getTime() + 60 * 60 * 1000);
    this.createEventModalRef = this.dialog.open(this.createEventModal, {
      disableClose: true,
    });
    this.createEventModalRef.afterClosed().subscribe((result) => {
      this.closeCreateEventModal();
    });
  }

  closeCreateEventModal() {
    this.createEventModalRef.close();
    this.create_meeting_data = {
      topic: "",
      start_date: "",
      end_date: "",
      duration: "",
      timezone: "",
    };
    this.create_meeting_data_errors = {
      topic: false,
      start_date: false,
      end_date: false,
      duration: false,
      timezone: false,
    };
  }

  event_loader: boolean = false;
  createEventData() {
    if (this.create_meeting_data.topic != null && this.create_meeting_data.topic != "") {
      this.create_meeting_data_errors.topic = false;
    } else {
      this.create_meeting_data_errors.topic = true;
    }

    if (this.create_meeting_data.duration != null && this.create_meeting_data.duration != "") {
      this.create_meeting_data_errors.duration = false;
    } else {
      this.create_meeting_data_errors.duration = true;
    }

    if (this.create_meeting_data.timezone != null && this.create_meeting_data.timezone != "") {
      this.create_meeting_data_errors.timezone = false;
    } else {
      this.create_meeting_data_errors.timezone = true;
    }

    if (
      this.create_meeting_data_errors.topic == false &&
      this.create_meeting_data_errors.duration == false &&
      this.create_meeting_data_errors.timezone == false
    ) {
      this.event_loader = true;
      // let payload: any = this.create_meeting_data;
      const date = new Date(this.create_meeting_data.start_date);
      const formatted_date = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');

      let payload: any = {
        topic: this.create_meeting_data.topic,
        // start_date: new Date(this.create_meeting_data.start_date).toISOString().split('T')[0],
        start_date: formatted_date,
        start_time_full: new Date(this.create_meeting_data.start_date).toTimeString().split(' ')[0],
        duration: this.create_meeting_data.duration,
        timezone: this.create_meeting_data.timezone,
        unique_id: this.user_id,
      };
      this.commonService.postData('/schedulegooglemeeting/', payload).subscribe(
        (res: any) => {
          this.getEventsData();
          this.closeCreateEventModal();
          this.event_loader = false;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
          this.event_loader = false;
        },
      );
    }


  }

  createEvent(date: Date) {
    const title = prompt('Enter Meeting title');

    if (!title) return;

    const newEvent: CalendarEvent = {
      start: date,
      end: new Date(date.getTime() + 60 * 60 * 1000), // +1 hr
      title
    };

    this.events = [...this.events, newEvent];
  }

  onDayClick(date: Date) {
  const isEventExists = this.events.some(
    e => new Date(e.start).toDateString() === date.toDateString()
  );

  if (!isEventExists) {
    this.createEvent(date);
  }
}

}
